module.exports = __webpack_public_path__ + "static/media/loading.46882e8d.png";